import API from "serviceshift-ui/api-client";

const getCSRFToken = () =>
  document.querySelector('meta[name="csrf-token"]').content;

export default {
  fetchTenantCustomizations({ commit }) {
    // Get tenant id from url
    const subdomain = window.location.hostname.split(".")[0];
    return API.tenant.getCustomizations(subdomain).then((res) => {
      commit("replace", {
        state: "tenantCustomizations",
        data: res.data
      });
    });
  },
  fetchTenant({ commit }) {
    // Get tenant id from url
    const subdomain = window.location.hostname.split(".")[0];
    commit("replace", {
      state: "fetchingTenant",
      data: true
    });
    return API.tenant
      .getBySubdomain(subdomain)
      .then((res) => {
        commit("replace", {
          state: "tenant",
          data: res.data
        });
      })
      .finally(() => {
        commit("replace", {
          state: "fetchingTenant",
          data: false
        });
      });
  },
  async updateTenant(_, { link, data }) {
    await API.makeRequest(link, {
      headers: {
        "x-csrf-token": getCSRFToken()
      },
      withCredentials: true,
      method: "PUT",
      data
    });
  },
  async createTenant(_, { link, data }) {
    const res = await API.makeRequest(link, {
      headers: {
        "x-csrf-token": getCSRFToken()
      },
      withCredentials: true,
      method: "POST",
      data
    });
    return res.data;
  },
  async createTenantClone(_, { link, data }) {
    await API.makeRequest(link, {
      headers: {
        "x-csrf-token": getCSRFToken()
      },
      withCredentials: true,
      method: "POST",
      data
    });
  },
  async fetchCloneOptions(_, { tenantId }) {
    const res = await API.makeRequest(`/tenants/${tenantId}/clone_options`, {
      method: "GET"
    });
    return res.data;
  },
  setGoogleTimezoneAPIKey({ commit }, key) {
    commit("replace", {
      state: "googleTimezoneAPIKey",
      data: key
    })
  },
  async manageTrial(_, {link, method, data}) {
    const response = await API.makeRequest(link, {
      headers: {
        "x-csrf-token": getCSRFToken(),
        "ContentType": "json"
      },
      withCredentials: true,
      method,
      data
    })

    window.location.href = response.data.redirect_to
  }
};
